import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "words-list-item-content" }
const _hoisted_3 = { class: "group-name" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  class: "footer",
  style: {"border-top":"1px solid #eee","padding-top":"5px"}
}

import {
  TUITranslateService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  TUIChatService,
} from '@tencentcloud/chat-uikit-engine';
import { ref, watchEffect } from '../../../../adapter-vue';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import wordsIconLight from '../../../../assets/icon/words-light.svg';
import wordsIconDark from '../../../../assets/icon/words-dark.svg';
// import { wordsList } from '../../utils/wordsList';
import { isEnabledMessageReadReceiptGlobal } from '../../utils/utils';
import { isPC, isUniFrameWork } from '../../../../utils/env';
import TUIChatConfig from '../../config';
import quickLanguageStore from '@/store/modules/quickLanguage'
import { searchQuickWordsApi } from '@/utils/user';
import pagination from '@/TUIKit/components/common/Pagination/index.vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['onDialogPopupShowOrHide'],
  setup(__props, { emit: __emit }) {

const currentPage = ref(1); // 当前页码
const pageSize = ref(12); // 每页显示的数量
const total = ref(0); // 总数量
const wordsList: any = ref([])

// 快捷语仓库
const quickLanguage = quickLanguageStore()

// 获取单词列表
const getWordsList = async () => {
  const res = await searchQuickWordsApi({ name: quickLanguage.currentText, pageSize: pageSize.value, pageNum: currentPage.value })
  wordsList.value = res.body?.list
  total.value = res.body?.count || 0;
}

const handleCurrentChange = (val: number) => {
  currentPage.value = val;
  getWordsList();
}


const wordsIcon = TUIChatConfig.getTheme() === 'dark' ? wordsIconDark : wordsIconLight;
const emits = __emit;
const currentConversation = ref<IConversationModel>();
const container = ref();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

watchEffect(() => {
  if (quickLanguage.show) {
    container?.value?.toggleDialogDisplay(true);
    wordsList.value = [...quickLanguage.contentList]
    total.value = quickLanguage.total
  } else {
    container?.value?.toggleDialogDisplay(false);
  }
})

// 选择快捷语后，把快捷语内容设置到pinia中，并隐藏快捷语弹窗
const selectWord = (selectWord: any) => {
  quickLanguage.setQuickLanguageText('') //先清空，防止监听不到
  quickLanguage.setQuickLanguageText(selectWord)
  quickLanguage.hide()
};

const closeDialog = () => {
  container?.value?.toggleDialogDisplay(false);
};

const onDialogShow = () => {
  emits('onDialogPopupShowOrHide', true);
};

const onDialogClose = () => {
  emits('onDialogPopupShowOrHide', false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolbarItemContainer, {
    ref_key: "container",
    ref: container,
    iconFile: _unref(wordsIcon),
    title: "常用语",
    needBottomPopup: true,
    iconWidth: 0,
    iconHeight: 0,
    onOnDialogShow: onDialogShow,
    onOnDialogClose: onDialogClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['words', !_unref(isPC) && 'words-h5'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['words-header', !_unref(isPC) && 'words-h5-header'])
        }, [
          (!_unref(isPC))
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(['words-header-close', !_unref(isPC) && 'words-h5-header-close']),
                onClick: closeDialog
              }, " 关闭 ", 2))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['words-list', !_unref(isPC) && 'words-h5-list'])
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wordsList), (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(['words-list-item', !_unref(isPC) && 'words-h5-list-item']),
                onClick: ($event: any) => (selectWord(item.phrasesContent))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(item.phrasesName), 1),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(item.phrasesContent), 1)
                ])
              ], 10, _hoisted_1))
            }), 128))
          ])
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          (_unref(wordsList).length)
            ? (_openBlock(), _createBlock(pagination, {
                key: 0,
                "current-page": _unref(currentPage),
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
                "page-size": _unref(pageSize),
                "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageSize) ? (pageSize).value = $event : null)),
                total: _unref(total),
                "page-sizes": [15, 25, 35, 50],
                layout: "total, prev, pager, next",
                background: true,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "close-dialog-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(quickLanguage).hide()))
          }, "关闭")
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["iconFile"]))
}
}

})